export default __webpack_public_path__ + "static/media/specialist.d223cb32.svg";